import Vue from 'vue';
import CmsSection from './components/ui/CmsSection';
import CmsLink from './components/ui/CmsLink';
import CmsImage from './components/ui/CmsImage';
Vue.component('cms-section', CmsSection);
Vue.component('cms-link', CmsLink);
Vue.component('cms-image', CmsImage);